import React, { useState, useEffect } from "react"
import axios from "axios"
import { ShimmerTitle, ShimmerPostItem } from "react-shimmer-effects"

import Filters from './Filters'
import Item from './Item'
import Pagination from './Pagination'

import { EVENTS_ENDPOINT } from '../utils/constants';

const Events = ( { params }, props ) => {
  const perPage                         = params?.size
  const [page, setPage]                 = useState( 1 )
  const [maxPages, setMaxPages]         = useState( 0 )
  const [events, setEvents]             = useState( '' )
  const [resultsCount, setResultsCount] = useState( '' )
  const [filterParams, setFilterParams] = useState(
    {
      category: [],
      region: [],
      expired: false
    }
  )

  const onFiltersChange = ( newFilters ) => {
    setFilterParams( newFilters )
  }

  useEffect(() => {
    const getEvents = async () => {
      let endpoint = EVENTS_ENDPOINT

      endpoint += '?page=' + page
      endpoint += '&per_page=' + ( params?.type?.name === 'teaser' ? 3 : perPage )

      if ( params?.type?.name === 'teaser' ) {
        if ( params?.category ) {
            endpoint += '&taxonomy=' + params.category
        }
      }

      if ( params?.type?.name === 'archive' ) {
        if ( filterParams.category.length > 0 ) {
          endpoint += '&taxonomy=' + filterParams.category
        }

        if ( filterParams.region.length > 0 ) {
          endpoint += '&region=' + filterParams.region
        }

        if ( filterParams.expired ) {
          endpoint += '&expired=' + filterParams.expired
        }
      }

      // Make events empty so the preloader is showned
      setResultsCount( '' )
      setEvents( '' )

      await axios.get(
        endpoint, {}
      )
      .then(( response ) => {
        setResultsCount( response.data.count )
        setEvents( response.data.results )
        setMaxPages( response.data.max_pages )
      })
      .catch((err) => {

      });
    }

    getEvents()
  }, [ page, perPage, filterParams ])

  if ( resultsCount === 0 ) {
    return (
      <>
        <div className="fkn-blocks__inner events-archive__inner">
          { params?.type && params?.type?.name === 'archive' && (
            <>
              <Filters
                params={ filterParams }
                filtersChange={ onFiltersChange }
              />
              <div className="events-archive__separator"></div>
            </>
          )}
          <div className="events-archive__cards-no-results">
            Vi fandt desværre ingen arrangementer der matchede din søgning
          </div>
        </div>
      </>
    )
  }

  if ( events === '' ) {
    return (
      <>
        <div className="fkn-blocks__inner events-archive__inner">
          { params?.type && params?.type?.name === 'archive' && (
            <>
              <Filters
                params={ filterParams }
                filtersChange={ onFiltersChange }
              />
              <div className="events-archive__separator-loading">
                <ShimmerTitle line={ 1 } variant="primary" />
              </div>
            </>
          )}
          <div className="events-archive__cards-loading">
            { params?.type && params?.type?.name === 'archive' && (
              <>
                <ShimmerPostItem card title text cta imageHeight={ 175 } />
                <ShimmerPostItem card title text cta imageHeight={ 175 } />
                <ShimmerPostItem card title text cta imageHeight={ 175 } />
                <ShimmerPostItem card title text cta imageHeight={ 175 } />
              </>
            )}
            { params?.type && params?.type?.name === 'teaser' && (
              <>
                <ShimmerPostItem card title text cta imageHeight={ 175 } />
                <ShimmerPostItem card title text cta imageHeight={ 175 } />
                <ShimmerPostItem card title text cta imageHeight={ 175 } />
              </>
            )}
          </div>
          { params?.type && params?.type?.name === 'archive' && (
            <Pagination
              page={ page }
              perPage={ perPage }
              maxPages={ maxPages }
              pageChange={ ( val ) => setPage( parseInt( val ) ) }
            />
          )}
        </div>
      </>
    )
  }

  return (
    <>
      <div className="fkn-blocks__inner events-archive__inner">
        { params?.type && params?.type?.name === 'archive' && (
          <>
            <Filters
              params={ filterParams }
              filtersChange={ onFiltersChange }
            />
            <div className="events-archive__separator"></div>
          </>
        )}
        <div className={ `events-archive__cards events-archive__cards-${ params?.type.name }` }>
          {
            events && events.map( item => {
              return (
                <Item item={ item } />
              )
            })
          }
        </div>
        { params?.type && params?.type?.name === 'archive' && (
          <Pagination
            page={ page }
            perPage={ perPage }
            maxPages={ maxPages }
            pageChange={ ( val ) => setPage( parseInt( val ) ) }
          />
        )}
      </div>
    </>
  )
}

export default Events;
